<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">KPIs Ventas</div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedCampaign"
            return-object
            @change="campaignSelected($event)"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Estructura Comercial"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedStructure"
            return-object
            @change="structureSelected($event)"
            ref="structureAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('structureAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedCrop"
            return-object
            @change="cropSelected($event)"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Vendedor"
            :items="salesmanItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedSalesman"
            return-object
            @change="salesmanSelected($event)"
            ref="salesmanAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('salesmanAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Distribuidor"
            :items="dealerItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            v-model="selectedDealer"
            return-object
            @change="dealerSelected($event)"
            ref="dealerAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('dealerAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Categoría de Cliente"
            :items="clientCategoryItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="clientCategorySelected($event)"
            ref="clientCategoryAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('clientCategoryAutocomplete')"
          ></v-autocomplete>
        </v-toolbar>
        <!-- more filters -->
        <v-toolbar>
          <v-autocomplete
            label="Genética"
            :items="geneticsItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="geneticsSelected($event)"
            ref="geneticsAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('geneticsAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Tecnología"
            :items="technologyItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="technologySelected($event)"
            ref="technologyAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('technologyAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="PG Observado"
            :items="observedPgItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="observedPgSelected($event)"
            ref="observedPgAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('observedPgAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Medio de Pago"
            :items="paymentFormItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="paymentFormSelected($event)"
            ref="paymentFormAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('paymentFormAutocomplete')"
          ></v-autocomplete>
        </v-toolbar>
        <!-- chart config -->
        <v-toolbar>
          <v-autocomplete
            label="Reporte"
            :items="reportTypeItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            v-model="selectedReportType"
            return-object
            @change="reportTypeSelected($event)"
            ref="reportTypeAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('reportTypeAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Valores"
            :items="valueItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            v-model="selectedValue"
            return-object
            @change="valueSelected($event)"
            ref="valueAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('valueAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Categorías"
            :items="categoryItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            v-model="selectedCategory"
            return-object
            @change="categorySelected($event)"
            ref="categoryAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('categoryAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Segmentación"
            :items="segmentationItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="segmentationSelected($event)"
            ref="segmentationAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('segmentationAutocomplete')"
          ></v-autocomplete>
          <v-progress-linear
            :active="loading"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
      </v-card>
      <!-- chart -->
      <div
        ref="chart-toolbar-container"
        class="mt-2 wdr-ui-element chart-toolbar-container"
        style="position: relative"
      >
        <div
          id="wdr-toolbar-wrapper"
          class="wdr-toolbar-ui wdr-ui-element"
          style="width: 100%;"
        >
          <ul id="wdr-toolbar">
            <div class="wdr-toolbar-group-right">
              <li id="wdr-tab-fullscreen">
                <a v-on:click.stop="enterChartFullScreen">
                  <div class="wdr-svg-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="70"
                      height="38"
                      viewBox="-17.5 774.5 36 36"
                    >
                      <title>menu_fullscreen_open</title>
                      <g fill="#555">
                        <path
                          d="M-7.5 779.976V777.5h-7v7h3v-2.752l3.758 4.067 1.74-1.846-4.342-4.003 2.844.01zM-7.742 799.096l-3.758 4.101V800.5h-3v7h7v-2h-2.618l-.049-.371 4.124-4.054-1.699-1.979zM8.746 785.913l3.754-4.092v2.679h3v-7h-7v2h2.602l.082.381-4.126 4.041 1.688 1.991zM13.5 800.5v2.598l-.382.074-4.058-4.003-1.882 1.575 4.006 3.756H8.5v3h7v-7h-2zM-4 786.5h9c1.104 0 2.5.908 2.5 2.011v7.996c0 1.103-1.396 1.993-2.5 1.993h-9c-1.104 0-2.5-.891-2.5-1.993v-8.005c0-1.103 1.396-2.002 2.5-2.002z"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <span>Pantalla completa</span>
                </a>
              </li>
            </div>
            <li id="wdr-tab-export">
              <a v-on:click.stop="exportChart">
                <div class="wdr-svg-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="-17.5 774.5 36 36"
                  >
                    <title>menu_export</title>
                    <g fill="#555">
                      <path
                        d="M15.446 795.615l-4.289-6.461c-.346-.515-.803-.654-1.428-.654H7.788c-.186 0-.346-.029-.363.156-.008.076.017.07.059.137l4.76 7.108c.042.06.034.337-.017.38-.025.025-.067.219-.102.219H6.699c-.194 0-.354-.063-.363.125-.305 3.23-3.174 5.495-6.407 5.192-2.81-.263-5.039-2.329-5.3-5.14-.009-.195-.168-.178-.363-.178h-5.401c-.076 0-.144-.281-.144-.357 0-.025.008-.157.017-.175l4.76-7.203c.102-.16.05-.245-.109-.347-.06-.035-.118.082-.187.082h-1.94c-.616 0-1.199.145-1.553.658l-4.664 6.547c-.203.304-.545.586-.545.95v9.216c1 .911 1.267 1.646 2.187 1.629h27.625c.903.009 1.188-.709 1.188-1.611v-9.233c1-.373.157-.735-.054-1.04z"
                      ></path>
                      <path
                        d="M-3.674 783.5H-2.5v10.2c1 1.4 1.764 2.464 3.165 2.371 1.274-.083 1.835-1.097 2.835-2.371v-10.2h1.207c.346 0 .641-.04.65-.387.008-.151-.042-.193-.144-.311l-4.186-5.11c-.228-.287-.642-.302-.929-.073-.042.034-.076.081-.101.115l-4.135 5.172c-.22.271-.187.447.084.668.11.085.244-.074.38-.074z"
                      ></path>
                    </g>
                  </svg>
                </div>
                <span>Exportar</span>
              </a>
            </li>
          </ul>
        </div>
        <div id="chart-container" ref="chartcontainer"></div>
      </div>
      <!-- pibot table -->
      <div id="pivot-container" class="mt-2"></div>
    </v-card-text>
  </v-card>
</template>
<script>
/* eslint-disable */
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.min.css";
import "webdatarocks/webdatarocks.toolbar";
import "webdatarocks/webdatarocks.amcharts";
import wdrEs from "@/assets/webDataRocksEs.json";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default {
  name: "SalesKPI",

  components: {
    //
  },

  data() {
    return {
      editMode: "show",
      campaignItems: [],
      cropItems: [],
      salesmanItems: [],
      geneticsItems: [],
      technologyItems: [],
      observedPgItems: [],
      paymentFormItems: [],
      clientCategoryItems: [],
      dealerItems: [],
      valueItems: [
        { id: 1, description: "Importe", title: "Importes USD" },
        { id: 2, description: "Bolsas", title: "Cantidad de Bolsas" },
        { id: 3, description: "Importe/Bolsas", title: "Importe USD y Cantidad de Bolsas" }
      ],
      categoryItems: [
        { id: 1, description: "Genética", typeId: 1 },
        { id: 2, description: "Tecnología", typeId: 2 },
        { id: 3, description: "PG Observado", typeId: 3 },
        { id: 4, description: "Medio de Pago", typeId: 4 },
        { id: 5, description: "Genética - Tecnología", typeId: 5 },
        { id: 6, description: "Genética - PG Observado", typeId: 6 },
        { id: 7, description: "Tecnología - PG Observado", typeId: 7 },
        { id: 8, description: "Genética - Tecnología - PG Observado", typeId: 8 },
        { id: 9, description: "Períodos", typeId: 9 },
        { id: 10, description: "Períodos (Acumulado)", typeId: 9 }
      ],
      segmentationItems: [
        { id: 1, description: "Precios" }
      ],
      reportTypeItems: [
        { id: 1, description: "Ventas", prefix: "vendido" },
        { id: 2, description: "Despachos", prefix: "entregado" },
        { id: 3, description: "Facturación", prefix: "facturado" }
      ],
      filterCampaign: null,
      filterStructure: null,
      filterCrop: null,
      filterSalesman: null,
      filterGenetics: null,
      filterTechnology: null,
      filterObservedPg: null,
      filterValue: null,
      filterCategory: null,
      filterSegmentation: null,
      filterPaymentForm: null,
      filterReportType: null,
      filterClientCategory: null,
      filterDealer: null,
      selectedCampaign: null,
      selectedStructure: null,
      selectedCrop: null,
      selectedValue: null,
      selectedCategory: null,
      selectedSegmentation: null,
      selectedReportType: null,
      selectedSalesman: null,
      selectedDealer: null,
      pivot: null,
      chart: null,
      title: null,
      rawData: [],
      priceSegments: [],
      loading: true
    };
  },

  methods: {
    async readDataFromAPI() {
      try {
        this.loading = true;
        if (
          this.filterCampaign &&
          this.filterStructure &&
          this.filterCrop &&
          this.filterValue &&
          this.filterCategory &&
          this.filterReportType
        ) {
          if (this.chart) {
            this.chart.dispose();
          }
          this.$refs["chartcontainer"].style.height = "500px"

          if (this.filterCategory.typeId === 9 && this.filterValue.id === 3) {
            throw "El gráfico de períodos solo puede mostrar un valor, elija importe o bolsas";
          }
          if (this.filterCategory.typeId === 9 && this.filterSegmentation) {
            throw "El gráfico de períodos no puede generarse con segmentación de columnas, elimine el valor del campo segmentación";
          }

          let commercial_person_type_level = this.filterCommercialPerson ? this.filterCommercialPerson.commercial_type_level : 0;
          let salesman_id = this.filterSalesman ? this.filterSalesman.salesman_id.toString() : "-1";
          let dealer_id = this.filterDealer ? this.filterDealer.dealer_id.toString() : "-1";
          let category = this.filterCategory.typeId.toString();
          let segmentation = this.filterSegmentation ? this.filterSegmentation.id.toString() : "0";
          let client_category = this.filterClientCategory ? this.filterClientCategory.id.toString() : "0";

          let endpoint =
            "/data/sales_kpi/" +
            this.filterCampaign.id.toString() +
            "/" +
            this.filterStructure.id.toString() +
            "/" +
            this.filterCrop.id.toString() +
            "/" +
            salesman_id +
            "/" +
            dealer_id;

          let title =
            this.filterReportType.description +
            " " +
            this.filterCampaign.description +
            ", Estructura Comercial: " +
            this.filterStructure.description +
            ", Cultivo: " +
            this.filterCrop.description +
            // eslint-disable-next-line
            (this.filterSalesman ? ", Vendedor: " + this.filterSalesman.description : "") +
            // eslint-disable-next-line
            (this.filterDealer ? ", Distribuidor: " + this.filterDealer.name : "");

          /* Filtro Genética */
          endpoint += this.filterGenetics ? "/" + this.filterGenetics.id.toString() : "/0";
          title += this.filterGenetics ? ", Genética: " + this.filterGenetics.description.substring(2, 100) : "";

          /* Filtro Tecnologia */
          endpoint += this.filterTechnology ? "/" + this.filterTechnology.id.toString() : "/0";
          title += this.filterTechnology ? ", Tecnología: " + this.filterTechnology.description.substring(2, 100) : "";

          /* Filtro pg Observado*/
          endpoint += this.filterObservedPg ? "/" + this.filterObservedPg.id.toString() : "/0";
          title += this.filterObservedPg ? ", " + this.filterObservedPg.description : "";

          /* Medio de Pago*/
          endpoint += this.filterPaymentForm ? "/" + this.filterPaymentForm.id.toString() : "/0";
          title += this.filterPaymentForm ? ", " + this.filterPaymentForm.description : "";

          /* Categoria */
          endpoint += "/" + category;

          /* Segmentación */
          endpoint += "/" + segmentation;

          /* Categoria de Cliente */
          endpoint += this.filterClientCategory ? "/" + this.filterClientCategory.id.toString() : "/0";
          title += this.filterClientCategory ? ", " + this.filterClientCategory.description.toString() : "";

          // Timestamp
          title += " (" + this.$moment().format("DD/MM/YYYY h:mm a") + ")";

          // eslint-disable-next-line
          let response = await this.$bRoot.search(endpoint);

          this.title = title;
          this.rawData = response.data;
          if (this.selectedSegmentation === 1) {
            this.priceSegments = this.getDistinctIdDescription(this.rawData, "segmento_precio_id", "segmento_precio_rango");
          }
          await this.loadPivotTable(this.rawData);
        } else {
          await this.unloadPivotTable();
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "campaignAutocomplete":
          this.filterCampaign = null;
          this.loadSalesmans();
          this.loadDealers();
          break;
        case "structureAutocomplete":
          this.filterStructure = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          this.loadDealers();
          break;
        case "salesmanAutocomplete":
          this.filterSalesman = null;
          break;
        case "geneticsAutocomplete":
          this.filterGenetics = null;
          break;
        case "technologyAutocomplete":
          this.filterTechnology = null;
          break;
        case "observedPgAutocomplete":
          this.filterObservedPg = null;
          break;
        case "valueAutocomplete":
          this.filterValue = null;
          break;
        case "categoryAutocomplete":
          this.filterCategory = null;
          break;
        case "segmentationAutocomplete":
          this.filterSegmentation = null;
          this.selectedSegmentation = null;
          break;
        case "paymentFormAutocomplete":
          this.filterPaymentForm = null;
          break;
        case "reportTypeAutocomplete":
          this.filterReportType = null;
          this.selectedReportType = null;
          break;
        case "clientCategoryAutocomplete":
          this.filterClientCategory = null;
          break;
        case "dealerAutocomplete":
          this.filterDealer = null;
          break;
      }
      this.readDataFromAPI();
    },

    campaignSelected(item) {
      this.filterCampaign = item;
      this.readDataFromAPI();
    },

    structureSelected(item) {
      this.filterStructure = item;
      this.loadSalesmans();
      this.loadDealers();
      this.readDataFromAPI();
    },

    cropSelected(item) {
      this.filterCrop = item;
      this.loadDealers();
      this.readDataFromAPI();
    },

    salesmanSelected(item) {
      this.filterSalesman = item;
      this.readDataFromAPI();
    },

    geneticsSelected(item) {
      this.filterGenetics = item;
      this.readDataFromAPI();
    },

    technologySelected(item) {
      this.filterTechnology = item;
      this.readDataFromAPI();
    },

    observedPgSelected(item) {
      this.filterObservedPg = item;
      this.readDataFromAPI();
    },

    paymentFormSelected(item) {
      this.filterPaymentForm = item;
      this.readDataFromAPI();
    },

    valueSelected(item) {
      this.filterValue = item;
      this.readDataFromAPI();
    },

    categorySelected(item) {
      this.filterCategory = item;
      this.readDataFromAPI();
    },

    segmentationSelected(item) {
      this.filterSegmentation = item;
      this.selectedSegmentation = item.id;
      this.readDataFromAPI();
    },

    reportTypeSelected(item) {
      this.filterReportType = item;
      this.readDataFromAPI();
    },

    clientCategorySelected(item) {
      this.filterClientCategory = item;
      this.readDataFromAPI();
    },

    dealerSelected(item) {
      this.filterDealer = item;
      this.readDataFromAPI();
    },

    async loadSalesmans() {
      this.salesmanItems = [];
      this.filterSalesman = null;
      this.selectedSalesman = null;
      let salesmans = null;
      if (this.filterStructure) {
        salesmans = await this.$bRoot.search(
          "/data/salesman_campaign_hierarchy",
          null,
          null,
          "campaign__id=" + this.filterStructure.id.toString()
        );
        this.salesmanItems = salesmans.data.results;
      }
    },

    async loadDealers() {
      this.dealerItems = [];
      this.filterDealer = null;
      this.selectedDealer = null;
      let dealers = null;
      if (this.filterStructure && this.filterCrop) {
        dealers = await this.$bRoot.search(
          "/data/dealers_campaign_crop_hierarchy" +
            "/" +
            this.filterStructure.id.toString() +
            "/" +
            this.filterCrop.id.toString(),
          null,
          null
        );
        if (dealers.data) {
          this.dealerItems = dealers.data;
        }
      }
    },

    async loadPivotTable(data) {
      let categoryId = this.filterCategory.id;
      let categoryTypeId = this.filterCategory.typeId;
      let measures = [];
      let columns = [];
      let rows = [];
      let column_definition = null;
      let ordering = null;
      let prefix = this.filterReportType.prefix;

      /*
        Siempre importe_total, cantidad_total, ..., precio_promedio, plazo_promedio
        Si se pide segmentación de precios
          ...: 4/8 columnas:
            importe_[segmento_descripcion] / cantidad_[segmento_descripcion]
        runningtotals tiene un error cuando se presentan múltiples columnas
      */
      if (categoryId != 10 || this.filterValue.id === 1) {
        measures.push({
          uniqueName:  prefix + "_usd",
          caption: "Importe Contado USD",
          aggregation: categoryId === 10 ? "runningtotals" : "sum",
          format: "f_importe"
        });
      }

      if (categoryId != 10 || this.filterValue.id === 1) {
        measures.push({
          uniqueName:  prefix + "_financiado_usd",
          caption: "Importe Financiado USD",
          aggregation: categoryId === 10 ? "runningtotals" : "sum",
          format: "f_importe"
        });
      }

      if (categoryId != 10 || this.filterValue.id === 2) {
        measures.push({
          uniqueName: prefix + "_cantidad",
          caption: "Cantidad Bolsas",
          aggregation: categoryId === 10 ? "runningtotals" : "sum",
          format: "f_valor"
        });
      }

      if (this.selectedSegmentation === 1) {
        if (this.filterValue.id === 1 || this.filterValue.id === 3) {
          this.priceSegments.map(item => {
            measures.push({
              uniqueName: "importe_" + item.id.toString(),
              caption: "USD Total " + item.description,
              individual: true,
              formula: 'IF("segmento_precio_id" == ' + item.id.toString() + ', "' + prefix + '_usd", 0)',
              aggregation: "sum",
              format: "f_importe"
            });
          });
          this.priceSegments.map(item => {
            measures.push({
              uniqueName: "importe_financiado_" + item.id.toString(),
              caption: "USD Financiado Total " + item.description,
              individual: true,
              formula: 'IF("segmento_precio_id" == ' + item.id.toString() + ', "' + prefix + '_financiado_usd", 0)',
              aggregation: "sum",
              format: "f_importe"
            });
          });
        }
        if (this.filterValue.id === 2 || this.filterValue.id === 3) {
          this.priceSegments.map(item => {
            measures.push({
              uniqueName: "cantidad_" + item.id.toString(),
              caption: "Cantidad " + item.description,
              individual: true,
              formula: 'IF("segmento_precio_id" == ' + item.id.toString() + ', "' + prefix + '_cantidad", 0)',
              aggregation: "sum",
              format: "f_importe"
            });
          });
        }
      }

      if (categoryId !== 10) {
        measures.push(
          /* Precio Promedio */
          {
            uniqueName: "precio_promedio",
            caption: "Precio Promedio Contado USD",
            formula: '"' + prefix + '_usd" / "' + prefix + '_cantidad"',
            aggregation: "sum",
            format: "f_importe"
          },
          /* Plazo Promedio */
          {
            uniqueName: "acum_plazo",
            caption: "Plazo Ponderado Acumulado",
            formula: '"' + prefix + '_financiado_usd" * "plazo_promedio"',
            individual: true,
            aggregation: "sum",
            active: false
          },
          {
            uniqueName: "plazo_promedio_ponderado",
            caption: "Plazo de Pago Promedio Ponderado",
            formula: '"acum_plazo" / "' + prefix + '_financiado_usd"',
            aggregation: "sum",
            format: "f_valor"
          },
          /* Precio Financiado Promedio */
          {
            uniqueName: "precio_financiado_promedio",
            caption: "Precio Promedio Financiado USD",
            formula: '"' + prefix + '_financiado_usd" / "' + prefix + '_cantidad"',
            aggregation: "sum",
            format: "f_importe"
          },
          /* Plazo Venta Promedio */
          {
            uniqueName: "acum_plazo_venta",
            caption: "Plazo Venta Ponderado Acumulado",
            formula: '"' + prefix + '_financiado_usd" * "plazo_venta_promedio"',
            individual: true,
            aggregation: "sum",
            active: false
          },
          {
            uniqueName: "plazo_venta_promedio_ponderado",
            caption: "Plazo de Venta Promedio Ponderado",
            formula: '"acum_plazo_venta" / "' + prefix + '_financiado_usd"',
            aggregation: "sum",
            format: "f_valor"
          }
        );
      }

      if (this.selectedSegmentation) {
        /* add empty column to running totals */
        measures.push({
          uniqueName: "none",
          caption: "Vacia",
          formula: '"' + prefix + '_usd" * 0',
          aggregation: "sum",
          format: "f_valor"
        });
      }

      /* configure columns */
      columns.push({ uniqueName: "Measures" });

      /* configure rows*/
      rows.push({uniqueName: "categoria"});
      if (categoryTypeId !== 9) {
        ordering = prefix + (this.filterValue.id === 1 ? "_usd" : "_cantidad");
      }

      /* Column definition */
      column_definition = {
        id: { type: "string" },
        categoria: { type: categoryTypeId === 9 ? "date string" : "string" },
        segmento_precio_id: { type: "number" },
        segmento_precio_rango: { type: "string" },
        vendido_cantidad: { type: "number" },
        entregado_cantidad: { type: "number" },
        facturado_cantidad: { type: "number" },
        vendido_usd: { type: "number" },
        entregado_usd: { type: "number" },
        facturado_usd: { type: "number" },
        vendido_financiado_usd: { type: "number" },
        entregado_financiado_usd: { type: "number" },
        facturado_financiado_usd: { type: "number" },
        plazo_promedio: 18,
        plazo_venta_promedio: 18
        };
      data.unshift(column_definition);

      /*Create Pivot Table*/
      this.pivot = new WebDataRocks({
        container: "#pivot-container",
        toolbar: true,
        beforetoolbarcreated: this.customizeToolbar,
        reportcomplete: this.createChart,
        global: {
          localization: wdrEs
        },
        report: {
          options: {
            datePattern: "yyyy-MM-DD",
            showAggregationLabels: false,
            grid: {
              type: "compact",
              showHeaders: false,
              showTotals: "on",
              showGrandTotals: "on",
              title: this.title
            },
            configuratorButton: false
          },
          dataSource: {
            data: data
          },
          slice: {
            rows: rows,
            columns: columns,
            measures: measures,
            sorting: {
              column: {
                type: "desc",
                tuple: [],
                measure: ordering
              }
            },
            expands: {
              expandAll: true
            }
          },
          formats: [
            {
              name: "f_importe",
              thousandsSeparator: ".",
              decimalSeparator: ",",
              decimalPlaces: 2,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_valor",
              thousandsSeparator: ".",
              decimalPlaces: 0,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_porcentaje",
              thousandsSeparator: ".",
              decimalPlaces: 2,
              decimalSeparator: ",",
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: true
            }
          ]
        }
      });
    },

    customizeToolbar(toolbar) {
      var tabs = toolbar.getTabs();
      tabs.forEach((tab, index) => {
        if (!(tab.id == "wdr-tab-fullscreen" || tab.id == "wdr-tab-export")) {
          delete tabs[index];
        }
      });
      toolbar.getTabs = function() {
        return tabs;
      };
    },

    async unloadPivotTable() {
      this.pivot = null;
    },

    createChart() {
      if (this.filterCategory.typeId === 9) {
        this.pivot.amcharts.getData({}, this.drawDateChart, this.updateChart);
      } else {
        this.pivot.amcharts.getData({}, this.drawCategoryChart, this.updateChart);
      }
    },

    updateChart(chartData, rawData) {
      if (this.chart) {
        this.chart.dispose();
      }
      if (this.filterCategory.typeId === 9) {
        this.drawDateChart(chartData, rawData);
      } else {
        this.drawCategoryChart(chartData, rawData);
      }
    },

    drawCategoryChart(chartData, rawData) {
      let logarithmic = (this.filterValue.id === 3 ? true : false);

      /*Crear chart*/
      am4core.useTheme(am4themes_animated);
      this.chart = am4core.create("chart-container", am4charts.XYChart);

      this.chart.colors.list = [
        am4core.color("#b1caf0"),
        am4core.color("#6fbdd9"),
        am4core.color("#73a3eb"),
        am4core.color("#5639e6"),
        am4core.color("#d2e8be"),
        am4core.color("#9eed93"),
        am4core.color("#3fcc5e"),
        am4core.color("#12b86d")
      ];

      this.chart.data = chartData.data;
      let title = this.chart.titles.create();
      title.text = this.title;
      title.fontSize = 18;
      title.marginBottom = 30;
      this.chart.numberFormatter.numberFormat = "#.0a";
      this.chart.legend = new am4charts.Legend();

      /* Configurar Categorias */
      var categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = this.pivot.amcharts.getCategoryName(rawData);
      categoryAxis.renderer.inversed = true;
      categoryAxis.fontSize = 11;
      categoryAxis.renderer.minGridDistance = 10;
      categoryAxis.renderer.cellStartLocation = 0.2;
      categoryAxis.renderer.cellEndLocation = 0.8;

      if (!this.selectedSegmentation) {
        if (this.filterValue.id === 1 || this.filterValue.id === 3) {
          this.createAxis("Ventas Totales en USD", this.filterValue.id === 3 ? true : false, logarithmic);
          this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 0), false, true);
        }
        if(this.filterValue.id === 2 || this.filterValue.id === 3) {
          this.createAxis("Ventas Totales en Bolsas", false, logarithmic);
          this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 1), false, true);
        }
      } else {
        switch (this.filterValue.id) {
          case 1:
            this.createAxis("Ventas Totales en USD", this.filterValue.id === 3 ? true : false, logarithmic);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 2), false, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 3), true, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 4), true, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 5), true, false);
            this.createTotalSeries();
            break;
          case 2:
            this.createAxis("Ventas Totales en Bolsas", this.filterValue.id === 3 ? true : false, logarithmic);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 2), false, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 3), true, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 4), true, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 5), true, false);
            this.createTotalSeries();
            break;
          case 3:
            this.createAxis("Ventas Totales en USD", this.filterValue.id === 3 ? true : false, logarithmic);
            this.createAxis("Ventas Totales en Bolsas", false, logarithmic);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 2), false, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 3), true, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 4), true, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 5), true, false);
            this.createTotalSeries();
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 6), false, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 7), true, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 8), true, false);
            this.createSeries(this.pivot.amcharts.getMeasureNameByIndex(rawData, 9), true, false);
            //this.createTotalSeries(); /* amchart bug totals does not reset when clustered and stacked columns exists */
            break;
        }
      }

      /* Resize */
      this.chart.events.on("datavalidated", () => {
        let cellSize = 30;
        let categoryAxis = this.chart.yAxes.getIndex(0);
        let adjustHeight =
          this.chart.data.length * cellSize - categoryAxis.pixelHeight;
        let targetHeight = this.chart.pixelHeight + adjustHeight;
        this.chart.svgContainer.htmlElement.style.height = targetHeight + "px";
      });
    },

    createAxis(name, opposite, logarithmic) {
      /* Configurar Eje de Valores */
      let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = name;
      valueAxis.logarithmic = logarithmic;
      valueAxis.treatZeroAs = 0.001; // evitar problemas con escalas logarítmicas y valores <= 0
      valueAxis.calculateTotals = (this.selectedSegmentation ? true : false);
      if (this.chart.xAxes.indexOf(valueAxis) != 0) {
        valueAxis.syncWithAxis = this.chart.xAxes.getIndex(0);
      }

      valueAxis.renderer.line.strokeOpacity = 1;
      valueAxis.renderer.line.strokeWidth = 2;
      valueAxis.renderer.labels.template.disabled = true;
      valueAxis.renderer.opposite = opposite;
    },

    createSeries(field, stack, bullets) {
      let series = this.chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.categoryY = "categoria";
      series.dataFields.valueX = field;
      series.showOnInit = true;
      series.columns.template.width = am4core.percent(60);
      series.stacked = stack;
      series.name = field;
      series.columns.template.tooltipText = "{name}: {valueX}";

      if (bullets) {
        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{valueX}";
        valueLabel.label.fontSize = 12;
        valueLabel.label.horizontalCenter = "left";
        valueLabel.label.dx = 5;
        valueLabel.label.truncate = false;
      }
    },

    createTotalSeries() {
      let series = this.chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.categoryY = "categoria";
      series.dataFields.valueX = "Vacia";
      series.hiddenInLegend = true;
      series.showOnInit = true;
      series.columns.template.width = am4core.percent(60);
      series.columns.template.strokeOpacity = 0;
      series.stacked = true;

      let valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = "{valueX.sum}";
      valueLabel.label.fontSize = 12;
      valueLabel.label.horizontalCenter = "left";
      valueLabel.label.dx = 5;
      valueLabel.label.truncate = false;
    },

    drawDateChart(chartData, rawData) {
      /*Crear chart*/
      am4core.useTheme(am4themes_animated);
      this.chart = am4core.create("chart-container", am4charts.XYChart);
      let field = this.pivot.amcharts.getMeasureNameByIndex(rawData, 0)

      this.chart.colors.list = [
        am4core.color("#b1caf0"),
        am4core.color("#6fbdd9"),
        am4core.color("#73a3eb"),
        am4core.color("#5639e6"),
        am4core.color("#d2e8be"),
        am4core.color("#9eed93"),
        am4core.color("#3fcc5e"),
        am4core.color("#12b86d")
      ];

      this.chart.data = chartData.data;
      let title = this.chart.titles.create();
      title.text = this.title;
      title.fontSize = 18;
      title.marginBottom = 30;
      this.chart.numberFormatter.numberFormat = "#.0a";
      this.chart.legend = new am4charts.Legend();

      /* Configurar Categorias */
      var categoryAxis = this.chart.xAxes.push(new am4charts.DateAxis());
      categoryAxis.dataFields.category = this.pivot.amcharts.getCategoryName(rawData);

      /* Configurar Eje de Valores */
      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = this.filterValue.id === 1 ? "Ventas Totales en USD" : "Ventas Totales en Bolsas";

      let series = this.chart.series.push(new am4charts.LineSeries());
      series.dataFields.dateX = this.pivot.amcharts.getCategoryName(rawData);
      series.dataFields.valueY = field;
      series.showOnInit = true;
      series.name = this.filterValue.id === 1 ? "Ventas Totales en USD" : "Ventas Totales en Bolsas";
      series.tooltipText = "{dateX}: {valueY}";
      series.strokeWidth = 2;

      if (this.filterCategory.id === 9) {
        var bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.stroke = am4core.color("#fff");
        bullet.circle.strokeWidth = 2;
      }

      this.chart.cursor = new am4charts.XYCursor();

      var scrollbar = new am4charts.XYChartScrollbar();
      scrollbar.series.push(series);
      this.chart.scrollbarX = scrollbar;
    },

    enterChartFullScreen() {
      let element = this.$refs["chart-toolbar-container"];
      if (
        element.requestFullscreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullscreen
      ) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
    },

    exportChart() {
      Promise.all([
        this.chart.exporting.pdfmake,
        this.chart.exporting.getImage("png")
      ])
        .then(res => {
          let pdfMake = res[0];
          let doc = {
            pageSize: "A4",
            pageOrientation: "portrait",
            pageMargins: [30, 30, 30, 30],
            content: []
          };
          doc.content.push({
            image: res[1],
            width: 530
          });
          pdfMake.createPdf(doc).download("grafico.pdf");
        })
        .catch(error => {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(error);
          }
        });
    },

    getDistinctIdDescription(data, idField, descriptionField) {
      const result = [];
      const map = new Map();
      for (const item of data) {
        if (!map.has(item[idField])) {
          map.set(item[idField], true);
          result.push({
            id: item[idField],
            description: item[descriptionField]
          });
        }
      }
      result.sort((a, b) => (a.id > b.id) ? 1 : -1);
      return result;
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.current_level = this.$bRoot.auth.current_level;
    let campaigns = null,
      crops = null,
      index = -1;

    try {
      //load campaigns
      campaigns = await this.$bRoot.search("/data/campaigns", null, "-code");
      this.campaignItems = campaigns.data.results;

      //set default
      let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
      index = this.campaignItems.findIndex(item => item.id == defaultCampaignId);
      if (index == -1) {
        index = this.campaignItems.findIndex(item => item.current === true);
      }
      if (index !== -1) {
        this.selectedCampaign = this.campaignItems[index].url;
        this.filterCampaign = this.campaignItems[index];
        this.selectedStructure = this.campaignItems[index].url;
        this.filterStructure = this.campaignItems[index];
      }

      //load crops
      crops = await this.$bRoot.search("/data/crops", null, "description");
      this.cropItems = crops.data.results;

      //set default
      let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
      index = this.cropItems.findIndex(item => item.id === defaultCropId);
      if (index !== -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }

      //commercial persons
      let commercialPersons = await this.$bRoot.searchAll(
        "/data/commercial_persons_hierarchy",
        null,
        "name"
      );
      this.commercialPersonItems = commercialPersons;

      //genetics
      let genetics = await this.$bRoot.searchAll(
        "/data/genetics",
        null,
        "description"
      );
      this.geneticsItems = genetics;

      //technologies
      let technologies = await this.$bRoot.searchAll(
        "/data/technologies",
        null,
        "description"
      );
      this.technologyItems = technologies;

      //observed pgs
      let observedPgs = await this.$bRoot.searchAll(
        "/data/observed_pgs",
        null,
        "description"
      );
      this.observedPgItems = observedPgs;

      //payment forms
      let paymentForms = await this.$bRoot.searchAll(
        "/data/payment_forms",
        null,
        "description"
      );
      this.paymentFormItems = paymentForms;

      /*Client Categories*/
      let clientCategories = await this.$bRoot.searchAll(
        "/data/categories",
        null,
        "description"
      );
      this.clientCategoryItems = clientCategories;

      //default value
      this.selectedValue = 1;
      this.filterValue = this.valueItems[0];

      //default category
      this.selectedCategory = 1;
      this.filterCategory = this.categoryItems[0];

      //default reportType
      this.selectedReportType = 1;
      this.filterReportType = this.reportTypeItems[0];

      //Salesmans and Dealers
      await this.loadSalesmans();
      await this.loadDealers();

      this.readDataFromAPI();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.loading = false;
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>
<style>
.wdr-credits {
  display: none;
}
.chart-toolbar-container:fullscreen {
  background-color: #ffffff;
  overflow-y: auto;
}
</style>
